import * as React from 'react';
import { AnimatePresence, AnimatePresenceProps } from 'framer-motion';

export interface IAnimationLayoutProps extends AnimatePresenceProps {
  children?: React.ReactNode;
  className?: string;
  id?: string;
}

export const AnimationLayout = ({
  initial = false,
  exitBeforeEnter = true,
  children,
  ...animation
}: IAnimationLayoutProps) => (
  <AnimatePresence initial={initial} exitBeforeEnter={exitBeforeEnter} {...animation}>
    {children}
  </AnimatePresence>
);
